import AcceptedCookies from '@/types/AcceptedCookies';
import { consentState } from '@/app-preferences';

declare global {
	interface Window {
		gtag?: (...args: any[]) => void;
	}
}
const selectState = (isAccepted: boolean) => {
	return isAccepted ? consentState.ACCEPTED : consentState.REJECTED;
}
const updateConsent = (c: AcceptedCookies) => {
	const { isAnalyticsCookiesAccepted, advertiseCookies } = c;
	const mapping = {
		analytics_storage: selectState(isAnalyticsCookiesAccepted),
		ad_storage: selectState(advertiseCookies),
		ad_user_data: selectState(advertiseCookies),
		ad_personalization: selectState(advertiseCookies),
	} as const;
	window.gtag?.('consent', 'update', mapping);
};
export default updateConsent;
